import React, { useState, useEffect } from "react";
import { CarouselContainer, ImageWrapper } from "./CarouselStyles";

const images = ["/assets/6.jpg", "/assets/7.jpg", "/assets/8.jpg"];

const Carousel = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <CarouselContainer>
      {images.map((src, index) => (
        <ImageWrapper key={index} $index={index} $activeIndex={activeIndex}>
          <img
            src={src}
            alt={`Slide ${index + 1}`}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              border: "2px solid white",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.4)",
            }}
          />
        </ImageWrapper>
      ))}
    </CarouselContainer>
  );
};

export default Carousel;
